/**
 * Validates that all activities in the Gantt chart have a valid unique_correlative_id
 * @param {Object} gantt - The Gantt chart object
 * @returns {boolean} - Returns true if all activities have a valid unique_correlative_id, false otherwise
 */
export const validateAllActivityUIDs = (gantt) => {
  const activities = gantt.getTaskByTime();

  const invalidActivity = activities.find(
    ({ unique_correlative_id }) => !unique_correlative_id
  );

  return !invalidActivity;
};

/**
 * Maps gantt tasks by their activity, grouping tasks under their parent activity
 * @param {Object} ganttInstance - The Gantt chart instance
 * @returns {Array} - Returns an array of activity objects with their tasks, or empty array if gantt instance is invalid
 */
export const mapTasksByActivity = (ganttInstance) => {
  // Return empty array if gantt instance is not valid
  if (!ganttInstance || !ganttInstance.getTaskByTime) {
    return [];
  }

  const tasks = ganttInstance.getTaskByTime();

  // Group tasks by activity (parent === 0 are activities, others are tasks)
  const activitiesMap = new Map();
  tasks.forEach((task) => {
    const activityId = task.parent === 0 ? task.id : task.parent;
    if (!activitiesMap.has(activityId)) {
      activitiesMap.set(activityId, {
        id: activityId,
        tasks: [],
        activity: null // Will be set when we find the activity instance
      });
    }

    // If this is an activity (parent === 0), store the reference
    if (task.parent === 0) {
      activitiesMap.get(activityId).activity = task;
    } else {
      // Only add actual tasks (not activities themselves) to the tasks array
      activitiesMap.get(activityId).tasks.push(task);
    }
  });

  return Array.from(activitiesMap.values());
};
